import logo from './logo.svg';
import './App.css';

//Importing componets
import Header from './Components/Header';
import Navbar from './Components/Navbar';
import Main from './Components/Main';
import Footer from './Components/Footer';
import Home from './Components/Home';
import Sign from './Components/Sign';
import Order from './Components/Order'
import Decor from './Components/Decor'
import Men from './Components/Men'
import Shoes from './Components/Shoes'
import Watches from './Components/Watches'
import Bag from './Components/Bag'
import Dress from './Components/Dress'
import Handbag from './Components/Handbag'
import Lwatches from "./Components/Lwatches"
import Earring from "./Components/Earring"
import Alexa1 from "./Components/Alexa1"
import Ac from "./Components/Ac"
import Mw from "./Components/Microwave"
import Fridge from "./Components/Fridge"
import Wm from "./Components/Washingm"
import Music from "./Components/Music"
import Construction from "./Components/Construction"
import Drawing from "./Components/Drawing"
import Chimney from "./Components/chimney"
import Cart from "./Components/Cart"
import Return from "./Components/MyOrder"
import Rack from "./Components/Shoerack"
import Frame from "./Components/Frames"
import Lamp from "./Components/Lamp"
import Mobile from "./Components/Mobiles"
import Payement from "./Components/Payement"
import Toy from "./Components/Toy"
import MyOrder from "./Components/MyOrder"
import  Amazonpay from "./Components/Amazonpay"

import Electronics from "./Components/Electronics"

import { useEffect } from "react"
import { useDispatch } from "react-redux"
import {auth} from './Firebase'
import Reduxpro1 from "./Components/reduxpro1"
import Reduxpro2 from "./Components/reduxpro2"

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Shoerack from './Components/Shoerack';



function App() {

  let dispatch = useDispatch();
  useEffect(() => {

    auth.onAuthStateChanged(authUser=>{

      console.log('The User is : ',authUser);
       if(authUser){
         dispatch({type : 'SET_USER' , user : authUser})
       }else{

         dispatch({type : 'SET_USER' , user : null})

       }

    })

  }, [])





  return (
    <div>
      <Router>
        <Switch>
          <Route exact path='/'>
            <Header></Header>
            <Navbar></Navbar>
            <Home></Home>
            <Footer></Footer>
          </Route>



          <Route path='/..'>
            <Header></Header>
            <Navbar></Navbar>
            <Home></Home>
            <Footer></Footer>
          </Route>
          <Route path='/order'>
            <Header></Header>
            <Navbar></Navbar>
            <Order></Order>
            <Footer></Footer>
          </Route>
          <Route path="/decor">
            <Header></Header>
            <Navbar></Navbar>
            <Decor></Decor>
            <Footer></Footer>
          </Route>
          <Route path="/men">
            <Header></Header>
            <Navbar></Navbar>
            <Men></Men>
            <Footer></Footer>
          </Route>
          <Route path="/shoes">
            <Header></Header>
            <Navbar></Navbar>
            <Shoes></Shoes>
            <Footer></Footer>
          </Route>
          <Route path="/watches">
            <Header></Header>
            <Navbar></Navbar>
            <Watches></Watches>
            <Footer></Footer>
          </Route>
          <Route path="/bag">
            <Header></Header>
            <Navbar></Navbar>
            <Bag></Bag>
            <Footer></Footer>
          </Route>
          <Route path="/dress">
            <Header></Header>
            <Navbar></Navbar>
            <Dress></Dress>
            <Footer></Footer>
          </Route>
          <Route path="/handbag">
            <Header></Header>
            <Navbar></Navbar>
            <Handbag></Handbag>
            <Footer></Footer>
          </Route>
          <Route path="/watches1">
            <Header></Header>
            <Navbar></Navbar>
            <Lwatches></Lwatches>
            <Footer></Footer>
          </Route>
          <Route path="/earring">
            <Header></Header>
            <Navbar></Navbar>
            <Earring></Earring>
            <Footer></Footer>
          </Route>
          <Route path="/alexa">
            <Header></Header>
            <Navbar></Navbar>
            <Alexa1></Alexa1>
            <Footer></Footer>
          </Route>
          <Route path="/ac">
            <Header></Header>
            <Navbar></Navbar>
            <Ac></Ac>
            <Footer></Footer>
          </Route>
          <Route path="/mw">
            <Header></Header>
            <Navbar></Navbar>
            <Mw></Mw>
            <Footer></Footer>
          </Route>
          <Route path="/fridge">
            <Header></Header>
            <Navbar></Navbar>
            <Fridge></Fridge>
            <Footer></Footer>
          </Route>
          <Route path="/wm">
            <Header></Header>
            <Navbar></Navbar>
            <Wm></Wm>
            <Footer></Footer>
          </Route>
          <Route path="/mi">
            <Header></Header>
            <Navbar></Navbar>
            <Music></Music>
            <Footer></Footer>
          </Route>
          <Route path="/ci">
            <Header></Header>
            <Navbar></Navbar>
            <Construction></Construction>
            <Footer></Footer>
          </Route>
          <Route path="/di">
            <Header></Header>
            <Navbar></Navbar>
            <Drawing></Drawing>
            <Footer></Footer>
          </Route>
          <Route path="/ei">
            <Header></Header>
            <Navbar></Navbar>
            <Electronics></Electronics>
            <Footer></Footer>
          </Route>
          <Route path="/sign">
            <Header></Header>
            <Navbar></Navbar>
            <Sign></Sign>
            <Footer></Footer>
          </Route>

          <Route path='/addtocart'>
            <Header></Header>
            <Navbar></Navbar>
            <Cart></Cart>
            <Footer></Footer>
          </Route>
          <Route path="/chim">
            <Header></Header>
            <Navbar></Navbar>
            <Chimney></Chimney>
            <Footer></Footer>
          </Route>

          <Route path="/return">
            <Header></Header>
            <Navbar></Navbar>
            <Return></Return>
            <Footer></Footer>
          </Route>

          <Route path="/rack">
            <Header></Header>
            <Navbar></Navbar>
            <Rack></Rack>
            <Footer></Footer>
          </Route>

          <Route path="/frame">
            <Header></Header>
            <Navbar></Navbar>
            <Frame></Frame>
            <Footer></Footer>
          </Route>
          <Route path="/lamp">
            <Header></Header>
            <Navbar></Navbar>
            <Lamp></Lamp>

            <Footer></Footer>
          </Route>

          <Route path="/mobile">
            <Header></Header>
            <Navbar></Navbar>
            <Mobile></Mobile>
            <Footer></Footer>
          </Route>

          <Route path="/payement">
            <Header></Header>
            <Navbar></Navbar>
            <Payement></Payement>
            <Footer></Footer>
          </Route>

          <Route path="/toy">
            <Header></Header>
            <Navbar></Navbar>
            <Toy></Toy>
            <Footer></Footer>
          </Route>
          <Route path="/pay">
            <Header></Header>
            <Navbar></Navbar>
            <Amazonpay></Amazonpay>
            <Footer></Footer>
          </Route>
          <Route path="/myorder">
            <Header></Header>
            <Navbar></Navbar>
            <MyOrder></MyOrder>
            <Footer></Footer>
          </Route>




        </Switch>




      </Router>

    </div>
  );
}

export default App;